import Hypher from 'hypher';
import hyphenationFi from 'hyphenation.fi';
import hyphenationEn from 'hyphenation.en-us';
import hyphenationSv from 'hyphenation.sv';
import $ from "jquery";

$(document).ready(function() {
  const minLength = 10;

  let language = $('html').attr('lang');
  let pattern = hyphenationFi;

  if (language === 'en') {
    pattern = hyphenationEn;
  } else if (language === 'sv') {
    pattern = hyphenationSv;
  }

  const hypher = new Hypher(pattern);
  $('h1, h2, h3, h4, h5, h6, table tr, table td, .js-hyphenate').each(function () {
    for (let node of this.childNodes)
      if (node.nodeType === 3) {
        node.nodeValue = hypher.hyphenateText(node.nodeValue, minLength);
    }
  });
});
